import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CoreConfig } from '@app/core/plugin';
import { CoreStateService } from '@app/core/services';
import { SocialNetwork, SOCIAL_NETWORKS } from '@app/layouts/utils/scaffold';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-labels-social-networks',
  templateUrl: './labels-social-networks.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelsSocialNetworksComponent implements OnInit {
  public socialNetworks$: Observable<any>;

  constructor(private coreStateService: CoreStateService) {}

  public ngOnInit() {
    this.socialNetworks$ = this.coreStateService.state$.pipe(map(this.combineValues));
  }

  private combineValues = (config: CoreConfig): SocialNetwork[] => {
    const socialNetworks = config.school.redes_sociais || {};

    return SOCIAL_NETWORKS.map((social) => ({
      ...social,
      href: socialNetworks[social.type] || config.plugin.handler.scaffold.socialLinks[social.type],
    })).filter(({ href }) => !!href);
  };
}
